// components/hooks/useLoadAllData.js

import { useState, useEffect } from "react";
import { useAuth } from '../components/context/AuthContext';

export const useLoadAllData = () => {
  const { fetchWithAuth, accessToken, handleLogout } = useAuth();

  const [kategorien, setKategorien] = useState(null);
  const [ablageorte, setAblageorte] = useState(null);
  const [typen, setTypen] = useState(null);
  const [laender, setLaender] = useState(null);
  const [materialien, setMaterialien] = useState(null);
  const [waehrungen, setWaehrungen] = useState(null);
  const [zustaende, setZustaende] = useState(null);
  const [eigentuemer, setEigentuemer] = useState(null);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        const [
          kategorienResponse,
          ablageorteResponse,
          typenResponse,
          laenderResponse,
          materialienResponse,
          waehrungenResponse,
          zustaendeResponse,
          eigentuemerResponse
        ] = await Promise.all([
          fetchWithAuth(`/api/data/kategorien`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }),
          fetchWithAuth(`/api/data/ablageorte`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }),
          fetchWithAuth(`/api/data/typen`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }),
          fetchWithAuth(`/api/data/laender`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            }
          }),
          fetchWithAuth(`/api/data/materialien`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            }
          }),
          fetchWithAuth(`/api/data/waehrungen`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }),
          fetchWithAuth(`/api/data/zustaende`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            }
          }),
          fetchWithAuth(`/api/data/eigentuemer`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            }
          })
        ]);

        // response 401 → redirect (session timeout or token invalid)
        if (
          kategorienResponse.status === 401 ||
          ablageorteResponse.status === 401 ||
          typenResponse.status === 401 ||
          laenderResponse.status === 401 ||
          materialienResponse.status === 401 ||
          waehrungenResponse.status === 401 ||
          zustaendeResponse.status === 401 ||
          eigentuemerResponse.status === 401
        ) {
          console.warn("401 Unauthorized – redirecting to login...");
          handleLogout();
          return;
        }

        // other errors
        if (!kategorienResponse.ok || !ablageorteResponse.ok || !typenResponse.ok || !laenderResponse.ok ||
            !materialienResponse.ok || !waehrungenResponse.ok || !zustaendeResponse.ok || !eigentuemerResponse.ok) {
          throw new Error("REST-Response: Fehler beim Laden der Daten (useLoadAllData.js)");
        }

        const kategorienData = await kategorienResponse.json();
        const ablageorteData = await ablageorteResponse.json();
        const typenData = await typenResponse.json();
        const laenderData = await laenderResponse.json();
        const materialienData = await materialienResponse.json();
        const waehrungenData = await waehrungenResponse.json();
        const zustaendeData = await zustaendeResponse.json();
        const eigentuemerData = await eigentuemerResponse.json();

        setKategorien(kategorienData);
        setAblageorte(ablageorteData);
        setTypen(typenData);
        setLaender(laenderData);
        setMaterialien(materialienData);
        setWaehrungen(waehrungenData);
        setZustaende(zustaendeData);
        setEigentuemer(eigentuemerData);

      } catch (error) {
        setError(error.message);
        console.error("Fehler beim Laden der Daten (useLoadAllData.js):", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAllData();
  }, [accessToken]);

  return {
    kategorien,
    ablageorte,
    typen,
    laender,
    materialien,
    waehrungen,
    zustaende,
    eigentuemer,

    loading,
    error
  };
};
